import { z } from "zod/v4";
import { defineEndpoint, defineResource, TenantPathParams } from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";
import { TenantScenarioStatusList } from "../fleet-messages/tenant-scenario-status-list";

/**
 * Resource definition for the traffic-flow `scenarios` list endpoint.
 *
 * Tenant-scoped: the URL is keyed by `tenantId` only — every camera/site under
 * the tenant is returned by a single request, with the handler filtering rows
 * the caller cannot access. `toPathTemplate(scenariosResource)` renders the
 * API Gateway template (`/api/v2/tenants/{tenantId}/features/traffic-flow/scenarios`);
 * the frontend client substitutes the real tenant id at request time.
 */
export const scenariosResource = defineResource({
  feature: FEATURE_NAME,
  resource: "scenarios",
  scope: "tenant",
});

/**
 * Path parameters for the scenarios list endpoint.
 */
export const ListScenariosPathParams = TenantPathParams;

export type ListScenariosPathParamsWire = z.input<typeof ListScenariosPathParams>;
export type ListScenariosPathParams = z.output<typeof ListScenariosPathParams>;

export { TenantScenarioStatusList as ListScenariosResponse };
export type { TenantScenarioStatusListWire as ListScenariosResponseWire } from "../fleet-messages/tenant-scenario-status-list";
export type { TenantScenarioStatusList as ListScenariosResponseDecoded } from "../fleet-messages/tenant-scenario-status-list";

/**
 * Endpoint definition consumed by both the CDK route registration and the
 * frontend `queryFor`/React Query hook. Mirrors the pattern used by
 * `features/a3s-media/src/client-messages/snapshots.ts:listSnapshotsEndpoint`
 * — single source of truth for resource + HTTP method + response codec.
 */
export const listScenariosEndpoint = defineEndpoint(scenariosResource, {
  responseSchema: TenantScenarioStatusList,
});
